const STATE_BOX = 'wysiwyg.viewer.components.StateBox'

export const stateBoxStateMetaData = {
    enforceContainerChildLimitsByWidth: true,
    enforceContainerChildLimitsByHeight: true,
    allowedParentTypes: [STATE_BOX]
}
